(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["styclov-palma-order-grid"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.palma-order-grid').forEach((root) => {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const minimum = 1;
    const currency = root.dataset.currency || 'EUR';
    const money = new Intl.NumberFormat('fr-FR', { style: 'currency', currency });
    const submit = root.querySelector('[data-submit]');
    const message = root.querySelector('[data-message]');

    const update = () => {
      let orderTotal = 0;
      root.querySelectorAll('.palma-order-row').forEach((row) => {
        let rowTotal = 0;
        let singleCount = 0;
        let singleTotal = 0;
        row.querySelectorAll('input[data-variant-id]').forEach((input) => {
          const quantity = Math.max(0, Number.parseInt(input.value || '0', 10));
          const price = Number(input.dataset.priceCents || 0);
          input.value = quantity;
          rowTotal += quantity * price;
          if (input.dataset.kind === 'single') {
            singleCount += quantity;
            singleTotal += quantity * price;
          }
        });
        const count = row.querySelector('[data-single-count]');
        const singlePrice = row.querySelector('[data-single-price]');
        if (count) count.textContent = singleCount;
        const sizePackInput = row.querySelector('input[data-kind="single"]');
        if (singlePrice && sizePackInput) singlePrice.textContent = `${money.format(Number(sizePackInput.dataset.priceCents || 0) / 100)} TTC / pack de 8`;
        row.querySelector('[data-row-total]').textContent = money.format(rowTotal / 100);
        row.dataset.singleCount = singleCount;
        orderTotal += rowTotal;
      });
      root.querySelector('[data-order-total]').textContent = money.format(orderTotal / 100);
    };

    root.addEventListener('click', (event) => {
      const button = event.target.closest('[data-increment], [data-decrement]');
      if (!button || button.disabled) return;
      const control = button.closest('[data-quantity-control]');
      const input = control.querySelector('input');
      if (!input || input.disabled) return;
      const current = Number.parseInt(input.value || '0', 10);
      input.value = button.hasAttribute('data-increment') ? current + 1 : Math.max(0, current - 1);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    root.addEventListener('change', (event) => {
      if (!event.target.matches('input[data-variant-id]')) return;
      event.target.value = Math.max(0, Number.parseInt(event.target.value || '0', 10));
      event.target.closest('.palma-order-row').querySelector('[data-row-error]').textContent = '';
      message.textContent = '';
      update();
    });

    submit.addEventListener('click', async () => {
      const items = [];
      let valid = true;
      root.querySelectorAll('.palma-order-row').forEach((row) => {
        const singleCount = Number(row.dataset.singleCount || 0);
        const error = row.querySelector('[data-row-error]');
        error.textContent = '';
        if (singleCount > 0 && singleCount < minimum) {
          error.textContent = root.dataset.minimumMessage.replace('[minimum]', minimum).replace('[color]', row.dataset.color);
          valid = false;
        }
        row.querySelectorAll('input[data-variant-id]').forEach((input) => {
          const quantity = Number.parseInt(input.value || '0', 10);
          if (!input.disabled && quantity > 0) items.push({ id: Number(input.dataset.variantId), quantity });
        });
      });

      if (!valid) return;
      if (items.length === 0) {
        message.textContent = root.dataset.emptyMessage;
        return;
      }

      submit.disabled = true;
      message.textContent = '';
      try {
        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items })
        });
        if (!response.ok) throw new Error('cart');
        window.location.href = `${window.Shopify.routes.root}cart`;
      } catch (error) {
        message.textContent = root.dataset.errorMessage;
        submit.disabled = false;
      }
    });

    update();
  });

  } catch(e) { console.error(e); }
})();
})();
